<template>
  <UserInteractiveForm
    :user="gtUser"
    :busy="busy"
    @submit="submit"
    @primary-key-changed="checkIfUserExists"
    @oauth-change="loginOAuthUser"
  />
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import UserInteractiveForm from '@/components/forms/user/interactive/UserInteractiveForm.vue'
export default {
  name: 'UserInteractiveFormContainer',
  components: {
    UserInteractiveForm,
  },
  props: {
    product: { type: String, default: 'personal_loan' },
    user: { type: Object, default: () => ({}) },
  },
  emits: ['userSubmitted'],
  data() {
    return {
      busy: false,
      usr: {},
    }
  },
  computed: {
    ...mapGetters({
      gtUser: 'user/user/gtUser',
    }),
  },
  methods: {
    ...mapActions({
      actTokenRegisterUser: 'token/actTokenRegisterUser',
      actOAuthRegisterUser: 'oauth/actOAuthRegisterUser',
      createFeedback: 'utils/feedback/createFeedback',
      actOAuthLogin: 'oauth/actOAuthLogin',
      actTokenLogin: 'token/actTokenLogin',
    }),
    async checkIfUserExists({ value, type }) {
      this.busy = true
      const response = await this.actTokenLogin({
        tokenRequest: {
          [type]: value,
          send_sms: true,
        },
        displayErrors: false,
      })

      if (response?.status >= 200 && response?.status <= 299) {
        this.redirectUserToLogin(type, value)
        return
      }
      this.busy = false
    },
    async loginOAuthUser({ accessToken, provider, email }) {
      this.busy = true
      const response = await this.actOAuthLogin({
        provider,
        accessToken,
      })
      if (response?.status === 200) {
        this.redirectUserToLogin('oauth')
        return
      }
      await this.checkIfUserExists({ type: 'email', value: email })
      this.busy = false
    },
    async submit({ user, accessToken, provider }) {
      if (this.busy) return

      if ((this.accessToken || accessToken) && (this.provider || provider)) {
        await this.oAuthRegisterUser(
          user,
          this.accessToken || accessToken,
          this.provider || provider,
        )
      } else {
        await this.tokenRegisterUser(user)
      }
    },
    async oAuthRegisterUser(user, accessToken, provider) {
      this.busy = true
      const response = await this.actOAuthRegisterUser({
        provider,
        user,
        accessToken,
      })

      this.handleUserCreationResponse(user, response)
      this.busy = false
    },
    async tokenRegisterUser(user) {
      this.busy = true
      const response = await this.actTokenRegisterUser(user)
      this.handleUserCreationResponse(user, response)
      this.busy = false
    },
    handleUserCreationResponse(user, response) {
      if (response?.status === 200) {
        this.$emit('userSubmitted')
        return
      }

      if (response?.status >= 400 && response?.status < 500) {
        if (response?.data?.reason === 'should be a valid email') {
          this.createFeedback({
            text: `O e-mail informado está incorreto.\nPor favor verifique, e tente novamente.`,
          })
          return
        }

        this.redirectUserToLogin('cpf', user.cpf)

        return
      }
      this.createFeedback({
        text: 'Ocorreu um erro ao tentarmos criar a sua conta! Por favor, tente novamente.',
      })
    },
    redirectUserToLogin(method, value) {
      const utmCampaign = sessionStorage.getItem('utm_campaign') || ''
      const utmSource = sessionStorage.getItem('utm_source') || ''
      const conditionalQueries = Object.assign(
        {},
        utmSource ? { utm_source: utmSource } : {},
        utmCampaign ? { utm_campaign: utmCampaign } : {},
        this.product ? { product: this.product } : {},
        this.$route.query || {},
      )

      if (method !== 'oauth') {
        sessionStorage.setItem(
          'jb.state.send-token-data',
          JSON.stringify({ method, value }),
        )

        this.createFeedback({
          text: 'Parece que você já possui uma conta conosco.\nPara continuar, basta realizar o login em sua conta.',
        })
      }

      this.$router.push({
        path: '/login',
        query: {
          ...conditionalQueries,
        },
      })
    },
  },
}
</script>
<style lang="scss"></style>
